export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7187.34abc977.jpg";